import { useAuthStore } from '@/store';

export default (to: any, from: any, next: Function) => {
  const authStore = useAuthStore();
  return authStore.authToken
    ? next('/')
    : next();
};
